import { render } from "./modalremove.vue?vue&type=template&id=f561edc4"
import script from "./modalremove.vue?vue&type=script&lang=js"
export * from "./modalremove.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__